const YOUTUBE_EMBED = "https://www.youtube.com/embed/";
const VIMEO_EMBED = "https://player.vimeo.com/video/";

const isYouTubeHost = (host: string) =>
  host === "youtube.com" ||
  host === "m.youtube.com" ||
  host === "youtube-nocookie.com" ||
  host === "youtu.be";

const youTubeId = (url: URL) => {
  if (url.hostname.replace(/^www\./, "") === "youtu.be") {
    return url.pathname.split("/").filter(Boolean)[0] || "";
  }

  const fromQuery = url.searchParams.get("v");
  if (fromQuery) {
    return fromQuery;
  }

  const segments = url.pathname.split("/").filter(Boolean);
  const keyword = segments[0];

  if (keyword === "embed" || keyword === "shorts" || keyword === "live") {
    return segments[1] || "";
  }

  return "";
};

/**
 * El CMS guarda `videoUrl` tal como la pegó la persona que edita, así que hay que
 * llevarla a la forma embebible antes de meterla en un iframe. Devuelve "" cuando
 * no se reconoce el proveedor: la UI muestra un link externo en vez de un iframe roto.
 */
export const toVideoEmbedUrl = (value: string) => {
  const trimmed = (value || "").trim();
  if (!trimmed) {
    return "";
  }

  let url: URL;
  try {
    url = new URL(trimmed);
  } catch (error) {
    return "";
  }

  if (url.protocol !== "http:" && url.protocol !== "https:") {
    return "";
  }

  const host = url.hostname.replace(/^www\./, "");

  if (isYouTubeHost(host)) {
    const id = youTubeId(url);
    return id ? `${YOUTUBE_EMBED}${encodeURIComponent(id)}` : "";
  }

  if (host === "vimeo.com" || host === "player.vimeo.com") {
    const id = url.pathname
      .split("/")
      .filter(Boolean)
      .filter((segment) => segment !== "video")[0];

    return id && /^\d+$/.test(id) ? `${VIMEO_EMBED}${id}` : "";
  }

  return "";
};

export default toVideoEmbedUrl;
